import {Injectable} from '@angular/core';

interface Messages {
  [key: string]: string;
}
function createStringFromTemplate(template, variables) {
  return template.replace(new RegExp('\{([^\{]+)\}', 'g'), function(_unused, varName){
    return variables[varName];
  });
}

@Injectable()
export class ValidatorMessageService {
  private _messages?: Messages = {};
  private _defaultMessages: Messages = {
    minlength: `min length {requiredLength}`,
    maxlength: 'max  length {requiredLength}',
    min: `min {requiredValue}`,
    max: `max {requiredValue}`,
    required: 'required',
    email: 'must be a valid email address',
    selectOne: 'select one'
  };
  set messages(messages: Messages ){
    this._messages = messages;
  }

  getMessage(key: string, err: any) {
    const msg = this._messages[key];
    const defMsg = this._defaultMessages[key];
    return createStringFromTemplate( msg ? msg : (defMsg ? defMsg : key) , err);

}


}



// WEBPACK FOOTER //
// ./src/app/core/services/validator-message.service.ts